export const apiUrl = process.env.API_URL;
export const root_url = process.env.VUE_APP_ROOT_API;
export const version = process.env.VUE_APP_VERSION;
export const userTokenStorageKey = "APP_USER_TOKEN";
export const authDisabled = false; /* Set to True to disable auth */
export const bridgeAngularJS = false;
export const permanent = true;
export const PermAdminRole = "Administrator";
export const DefaultPermissions = { home: { deny: false } };
export const Debug = process.env.NODE_ENV !== "production";
export const BaseURL = process.env.BASE_URL;
export const CentAPI = process.env.VUE_APP_CENT_API;

export const GoBackend = false;
export const OldValidationLogic = true; // Stop it using new logic just yet.
export const TurnOnComplexityChecking = true; // Use complexity checking for passwords
export const DEFAULT_CODE_LIMIT = 4000;

// export const JWT_COOKIE_ONLY = true;

export const FlatPickrNoNative = true;
export const CheckPageAccess = function (route, currentUser) {
  if (currentUser && !_.isEmpty(currentUser)) {
    // We are logged in!

    if ((currentUser.groups || []).length === 0) {
      return {
        deny: true,
        message:
          "This account is not in any groups. " +
          "Contact your system administrator for further " +
          "assistance.",
      };
    }

    if (currentUser.profile == null || _.isEmpty(currentUser.profile)) {
      return {
        deny: false,
        message:
          "The account you are using has no existing employee record. " +
          "Some features might not work. Contact your system administrator for further " +
          "assistance.",
      };
    }
  }
  return null;
};
export const DisableLocalStorage = true; // dont store anything in local storage
